import { post } from "../../helpers/apiWrapper";

export const createSignin = async (userData) => {
  const config = {
    data: userData,
  };
  return await post(`/login`, config);
};

export const createSignup = async (userData) => {
  const config = {
    data: userData,
  };
  return await post(`/register`, config);
};

export const createForgotPassword = async (data) => {
  const config = {
    data: data,
  };
  return await post(`/forgot-password`, config);
};

export const createResetPassword = async (data) => {
  const config = {
    data: data,
  };
  return await post(`/reset-password`, config);
};


export const createGoogleSignin = async (tokenData) => {
  const config = {
    data: tokenData,
  };
  return await post(`/google-signin`, config);
};

export const createGoogleSignup = async (tokenData) => {
  const config = {
    data: tokenData,
  };
  return await post(`/google-signup`, config);
};

// LinkedIn SSO endpoints
export const createLinkedInSignin = async (tokenData) => {
  const config = {
    data: tokenData,
  };
  return await post(`/linkdin-signin`, config);
};

export const createLinkedInSignup = async (tokenData) => {
  const config = {
    data: tokenData,
  };
  return await post(`/linkdin-signup`, config);
};

export const verifyAccount = async (token) => {
  const config = {
    data: token ,
  };
  return await post(`/account-verification`, config);
};

export const resendVerification = async () => {
  const config = {
    data: {  },
  };
  return await post(`/resend-verification`, config);
};